export const flagsSvg = Object.freeze([
  {
    lang: 'ar-sa',
    country: 'SA',
    path: 'ar-sa.svg',
  },
  {
    lang: 'de-de',
    country: 'DE',
    path: 'de-de.svg',
  },
  {
    lang: 'en',
    country: 'GB',
    path: 'en-gb.svg',
  },
  {
    lang: 'en-gb',
    country: 'GB',
    path: 'en-gb.svg',
  },
  {
    lang: 'fr',
    country: 'FR',
    path: 'fr-fr.svg',
  },
  {
    lang: 'fr-fr',
    country: 'FR',
    path: 'fr-fr.svg',
  },
  {
    lang: 'it-it',
    country: 'IT',
    path: 'it-it.svg',
  },
  {
    lang: 'ja-jp',
    country: 'JP',
    path: 'ja-jp.svg',
  },
  {
    lang: 'ko',
    country: 'KR',
    path: 'ko-kr.svg',
  },
  {
    lang: 'nl-nl',
    country: 'NL',
    path: 'nl-nl.svg',
  },
  {
    lang: 'pl-pl',
    country: 'PL',
    path: 'pl-pl.svg',
  },
  {
    lang: 'ru-ru',
    country: 'RU',
    path: 'ru-ru.svg',
  },
  {
    lang: 'th-th',
    country: 'TH',
    path: 'th-th.svg',
  },
  {
    lang: 'tr',
    country: 'TR',
    path: 'tr-tr.svg',
  },
  {
    lang: 'uk',
    country: 'UA',
    path: 'uk-ua.svg',
  },
  {
    lang: 'zh-cn',
    country: 'CN',
    path: 'zh-cn.svg',
  },
  {
    lang: 'zh-tw',
    country: 'TW',
    path: 'zh-tw.svg',
  },
])
